module.exports = __webpack_public_path__ + "img/reward-4.c41f6b62.svg";